<template>
  <div class="referral-wrapper">
    <div class="referral">
      <div class="header">
        Así funciona nuestro sistema de referidos
      </div>
      <div class="steps">
        <div class="step">
          <div class="step-number">1</div>
          <div class="step-title">
            Invita a todos tus amigos a invertir
          </div>
          <div class="step-description">
            Comparte tu link a todos tus conocidos usando el medio que prefieras.
          </div>
          <div class="links">
            <social-sharing
              class="social-component"
              :url="referralUrl"
              :title="'$100 de regalo en tu primera inversión. Vuelvete socio de tu restaurante favorito'"
              description="$100 de regalo en tu primera inversión. Ser socio de tu restaurante favorito nunca fue tan fácil"
              quote="Rendimientos anuales entre 12-15% de tu restaurante favorito "
              hashtags="flagship, invierte"
              inline-template>
              <div>
                <network class="link" network="email">
                  <span class="mdi mdi-email"></span> Correo electrónico
                </network>
                <network class="link" network="facebook">
                  <span class="mdi mdi-facebook-box"></span> Facebook
                </network>
                <network class="link" network="twitter">
                  <span class="mdi mdi-twitter-box"></span> Twitter
                </network>
                <network class="link" network="whatsapp">
                  <span class="mdi mdi-whatsapp"></span> Whatsapp
                </network>
                <network class="link" network="sms">
                  <span class="mdi mdi-cellphone-message"></span> SMS
                </network>
              </div>
            </social-sharing>
            <div class="custom-link">
              <input class="custom-input" id="copy-element" :value="referralUrl" readonly>
              <div class="copy-action" @click="copyReferralLink">
                {{ copyText }}
              </div>
            </div>
          </div>
        </div>
        <div class="step">
          <div class="step-number">2</div>
          <div class="step-title">
            Genera más cuando ellos inviertan
          </div>
          <div class="step-description">
            A cada amigo que invites se le bonificarán $100 pesos a su cuenta para su primera
            inversión en Flagship, mientras que a ti, al momento de que tu amigo relice una
            inversión exitosa en cualquier proyecto, te bonificaremos el 1% del total de su
            inversión.
          </div>
        </div>
        <div class="step">
          <div class="step-number">3</div>
          <div class="step-title">
            Observa cómo tu saldo invertido incrementa y sigue invitando
          </div>
          <div class="step-description">
            Cuando realices una nueva inversión, descontaremos de la inversión el crédito que
            tengas acumulado en el saldo de referidos, por lo que tendrás que pagar menos y
            recibirás más. Ej: Si quieres invertir $20,000 en un nuevo proyecto y tienes un saldo
            de referidos de $5,000 únicamente tendrás que pagar $15,000 al momento de invertir.
          </div>
        </div>
      </div>
      <div class="referral-list">
        <div class="list-header">
          Usuarios registrados con tu codigo:
        </div>
        <div class="user-element" v-for="referredUser in usersData.referredUsers" :key="referredUser.id">
          <div class="mail">
            <span class="mdi mdi-timer"></span> {{ referredUser.email }}
          </div>
          {{ moment(referredUser.created_at).format('DD MMM YYYY') }}
        </div>
        <div class="list-header">
          Usuarios que invirtieron con tu codigo:
        </div>
        <div class="user-element" v-for="referredUser in usersData.earnedUsers" :key="referredUser.id">
          <div class="mail">
            <span class="mdi mdi-currency-usd"></span> {{ referredUser.referredUser.email }}
          </div>
          Ganancia obtenida: {{ formatMoney(referredUser.creditEarned) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import axios from 'axios';
import socialSharing from 'vue-social-sharing';
import formatMixin from '@/mixins/formatMixin';
import moment from 'moment';

const { mapState, mapActions } = createNamespacedHelpers('user');
export default {
  data() {
    return {
      copyText: 'Copiar al portapapeles',
      usersData: [],
      moment,
    };
  },
  components: {
    socialSharing,
  },
  computed: {
    referralUrl() {
      if (this.user) {
        return `${process.env.VUE_APP_URL}/register?referralCode=${this.user.referralCode}`;
      }
      return null;
    },
    ...mapState([
      'user',
    ]),
  },
  methods: {
    copyReferralLink() {
      const element = document.querySelector('#copy-element');
      element.select();
      document.execCommand('copy');
      this.copyText = '¡Copiado!';
    },
    ...mapActions([
      'getUser',
    ]),
  },
  mixins: [formatMixin],
  async mounted() {
    await this.getUser();
    const { data } = await axios.get(`${process.env.VUE_APP_SERVER_URL}/user/referred`);
    this.usersData = data;
  },
};
</script>

<style lang="scss" scoped>
.referral-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #fafafa;
  font-family: 'Inter', sans-serif;
}
.referral {
  width: 900px;
  padding: 90px 20px 40px 20px;
  display: flex;
  flex-direction: column;
}
.header {
  width: 100%;
  padding: 15px 0;
  color: #202124;
  font-size: 32px;
  font-weight: bold;
  margin-top: 30px;
}
.steps {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.step {
  width: 30%;
}
.step-number {
  font-size: 48px;
  font-weight: bold;
  color: #3479e9;
}
.step-title {
  font-size: 24px;
  font-weight: bold;
  margin-top: 18px;
  // height: 58px;
  line-height: 1.8rem;
  color: #3479e9;
}
.step-description {
  margin-top: 20px;
  line-height: 1.4rem;
}
.social-component {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 15px;
}
/deep/ .link {
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    font-size: 24px;
    margin-right: 8px;
    color: #3479e9;
  }
}
.custom-input {
  width: 100%;
  border: 1px solid #d6d6d8;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: inherit;
  margin-top: 15px;

  &:focus {
    border: 1px solid #3479e9;
  }
}
.copy-action {
  text-align: end;
  color: #3479e9;
  font-size: 14px;
  margin-top: 6px;
  cursor: pointer;
}
.list-header {
  width: 100%;
  font-weight: bold;
  margin-top: 20px;
}
.user-element {
  margin: 10px 0;
  display: flex;
}
.mail {
  span {
    margin-right: 10px;
    font-size: 20px;
    color: #3479e9;
  }
  width: 50%;
}
.referral-list {
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .steps {
    flex-direction: column;
  }
  .step {
    width: 100%;
  }
}
</style>
